const SETSOLICITATIONS = (state, list) => {
  state.solicitacoes = list
}

const SETSOLICITATIONSPRIMEIROCARREGAMENTO = (state, list) => {
  state.solicitacoesPrimeiroCarregamento = list
}

const SETARCHIVES = (state, list) => {
  state.arquivos = list
}

const SETREASONSSABESP = (state, list) => {
  state.reasonsSabesp = list
}

const SETGROUPEDSOLICITATIONS = (state, list) => {
  state.groupedSolicitations = list
}

const SETGROUPEDSOLICITATIONSSTATUS = (state, list) => {
  state.groupedSolicitationsStatus = list
}

const SETMODALADDMSGSOLICITATIONINFO = (state, info) => {
  state.modalAddMsgSolicitationInfo = info
}

const SETOVERLAP = (state, info) => {
  state.overlap = info
}

const SETACTIVEPROTOCOL = (state, opts) => {
  state.activeProtocol = {
    protocolo: opts.protocol,
    tipoServico: opts.service
  }
}

const SETSOLICITATIONTOVIEW = (state, obj) => {
  state.solicitationToView = obj
}

const SETMODALALTERHISTORICODATA = (state, obj) => {
  state.modalAlterHistoricoData = obj
}

const SETALTERCANCELPERMISSION = (state, obj) => {
  state.alterCancelPermission = obj
}

const SETALTERCANCELCHANGES = (state, obj) => {
  state.alterCancelChanges = obj
}

export default {
  SETSOLICITATIONS,
  SETARCHIVES,
  SETREASONSSABESP,
  SETSOLICITATIONSPRIMEIROCARREGAMENTO,
  SETGROUPEDSOLICITATIONS,
  SETGROUPEDSOLICITATIONSSTATUS,
  SETMODALADDMSGSOLICITATIONINFO,
  SETOVERLAP,
  SETACTIVEPROTOCOL,
  SETSOLICITATIONTOVIEW,
  SETMODALALTERHISTORICODATA,
  SETALTERCANCELPERMISSION,
  SETALTERCANCELCHANGES
}
